var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { SchoolLog as SchoolLogModel } from '@/models/SchoolLog';
import SchoolLog from '@/components/SchoolLog/SchoolLog';
import ErrorHandler from '@/support/ErrorHandler';
import { debounce } from 'lodash';
let SchoolLogs = class SchoolLogs extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.logs = [];
        this.message = '';
        this.page = 1;
        this.isPostingMessage = false;
        this.onPaginationChange = debounce(this.paginationChanged, 500);
        this.isFocused = false;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    async mounted() {
        await this.fetchLogs();
    }
    // #endregion
    // #region Class methods
    paginationChanged(page) {
        this.page = page;
        this.fetchLogs();
    }
    onFocus() {
        this.isFocused = true;
    }
    onBlur() {
        this.isFocused = false;
    }
    // #endregion
    // #region Async methods
    async fetchLogs() {
        this.isLoading = true;
        this.logs = await new SchoolLogModel().include('user').page(this.page).limit(10).all();
        this.isLoading = false;
    }
    async postLog() {
        await new SchoolLogModel().create({ message: this.message });
    }
    async onClickSend() {
        this.isPostingMessage = true;
        const response = await new SchoolLogModel()
            .create({ message: this.message })
            .catch((error) => {
            ErrorHandler.network(error);
            this.isPostingMessage = false;
        });
        if (response) {
            await this.fetchLogs();
            this.message = '';
            this.isPostingMessage = false;
        }
    }
    // #endregion
    // #region Getters & Setters
    get lastPage() {
        return this.logs.length ? this.logs[0].meta.last_page : 1;
    }
    get total() {
        return this.logs.length ? this.logs[0].meta.total : 0;
    }
};
SchoolLogs = __decorate([
    Component({
        components: {
            SchoolLog,
        },
    })
], SchoolLogs);
export default SchoolLogs;
